import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Provider } from "jotai";
import "./locales/configs"; //i18
import { currentLocale } from "./Commons";

/**
 * currentLocaleから言語コードを抽出してhtml lang属性を設定
 * 例: "ja-JP" → "ja"
 */
const langCode = currentLocale.split("-")[0]; // "ja-JP" → "ja"
document.documentElement.lang = langCode;

/**
 * 本番環境(prod)ではconsole.infoを無効化
 * console.warnとconsole.errorは維持
 */
if (process.env.REACT_APP_ENVIRONMENT === "prod") {
  console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
